export default __webpack_public_path__ + "static/media/img-0741-romania-full-face.ec47ee36.png";